import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { ImageCard } from '~/components/ImageCard'
import { track } from '~/utils'
import { EXPLORE_FEED_ITEM_TAPPED, EXPLORE_FEED_ITEM_VIEWED } from '~/lib/tracking-events'
import ViewportTracking from '~/components/ViewportTracking'
import { decodeGlobalId } from '~/utils/id'
import { thumbnailWithUrlPropTypes } from '~/graphql/fragments/thumbnailWithUrl'

const WrappingButton = styled.button`
  width: 100%;
  text-align: start;
  cursor: pointer;
`

const UrlCard = ({ urlCollection, itemOrder }) => {
  const { id, type, status, title, subtitle, imageUrl, url } = urlCollection
  const employeeOnly = status === 'PREVIEW'

  const trackClick = () => {
    track(EXPLORE_FEED_ITEM_TAPPED, {
      itemId: decodeGlobalId(id),
      itemOrder,
      itemType: type,
      title,
    })
  }

  return (
    <ViewportTracking
      event={EXPLORE_FEED_ITEM_VIEWED}
      payload={{
        itemId: decodeGlobalId(id),
        itemOrder,
        itemType: type,
        title: title,
      }}
    >
      <WrappingButton
        onClick={() => {
          trackClick()
          window.location.href = url
        }}
      >
        <ImageCard title={title} text={subtitle} image={imageUrl} employeeOnly={employeeOnly} />
      </WrappingButton>
    </ViewportTracking>
  )
}

UrlCard.propTypes = {
  urlCollection: thumbnailWithUrlPropTypes.isRequired,
  itemOrder: PropTypes.number.isRequired,
}

export default UrlCard
